import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/system-common/services/base.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

export class NotificationServiceHandler extends BaseService {
  isAuditButtonClicked: boolean;
  forAuditSearchList: boolean;

  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService, '');
  }

  public init(modelNameList: string[]): Observable<Object> {
    return this.getCountNotification();
  }

  public load(id: any, modelNameList: string[], isMetadataReqd?: boolean): Observable<Object> {
    return this.getCountNotification();
  }
  public process(notificationSeq, notificationReadFlag): Observable<Object> {
    return;
  }
  public find(executeSearch?: boolean, searchCriteriaData?: any): Observable<Object> {
    return;
  }

  public findForLanding(executeSearch?: boolean, searchCriteriaData?: any) {
    return null;
  }

  getNotification(notificationType) {
    let body = {
      notificationType: notificationType,
    };
    return this.httpPost(`${this.getURLValue('NOTIFICATION')}/getNotifications`, body);
  }

  getCountNotification() {
    let body = {};
    return this.httpPost(`${this.getURLValue('NOTIFICATION')}/notificationCount`, body);
  }

  updateNotification(notificationSeq, notificationReadFlag) {
    let body = {
      notificationSeq: notificationSeq,
      notificationReadFl: notificationReadFlag,
    };
    return this.httpPost(`${this.getURLValue('NOTIFICATION')}/updateNotification`, body);
  }

  createNotification(notificationType, notificationMsg, notificationLang1, notificationLang2, notificationLink) {
    let body = {
      notificationType: notificationType,
      notificationMsg: notificationMsg,
      notificationLang1: notificationLang1,
      notificationLang2: notificationLang2,
      notificationLink: notificationLink,
    };

    return this.httpPost(`${this.getURLValue('NOTIFICATION')}/createNotification`, body);
  }
}
